var Tree_Alarm ={
    id: '1',
    label:'Alarm Configuration',
    pagename: 'Emptyjson',
    children:[
        {
            id: '2',
            label: 'Alarm Dashboard',
            pagename: 'AlarmConsumptionjson',
            children:[]
        },
    ]
    
}


export default Tree_Alarm;